module.exports = __webpack_public_path__ + "img/31_11.e3c78805.png";